import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledWizardFooter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const StyledWizardFooterCounter = styled.div`
    ${setFontVariant("button", colorsPalettes.bluegrey[600])};
    font-feature-settings: 'liga' off, 'clig' off;
`;

export const StyledWizardButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
`;